var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatFileRepeatIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3077 -0.00012207C16.9253 -0.00012207 16.6154 0.309835 16.6154 0.692186V3.57191C16.3438 3.29511 16.0286 3.00098 15.6695 2.70683C14.1979 1.50129 11.971 0.28149 9 0.28149C4.01198 0.28149 0 4.23824 0 9.14068C0 14.0446 4.04064 17.9999 9 17.9999C13.9594 17.9999 18 14.0446 18 9.14068C18 8.75833 17.69 8.44838 17.3077 8.44838C16.9253 8.44838 16.6154 8.75833 16.6154 9.14068C16.6154 13.2577 13.2171 16.6153 9 16.6153C4.78294 16.6153 1.38462 13.2577 1.38462 9.14068C1.38462 5.02223 4.75725 1.66611 9 1.66611C11.5675 1.66611 13.4944 2.71489 14.792 3.77792C15.2326 4.13884 15.5984 4.49983 15.8891 4.81865H13.0107C12.6283 4.81865 12.3184 5.12861 12.3184 5.51096C12.3184 5.89331 12.6283 6.20326 13.0107 6.20326H17.3077C17.69 6.20326 18 5.89331 18 5.51096V0.692186C18 0.309835 17.69 -0.00012207 17.3077 -0.00012207Z",
    fill: "#28447B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatFileRepeatIcon);
export default __webpack_public_path__ + "static/media/chatFileRepeatIcon.048efd11.svg";
export { ForwardRef as ReactComponent };